export enum RowTypeEnum {
  Empty = 'empty',
  Header = 'header',
  Metric = 'metric',
  Formula = 'formula'
}
